function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useFavicon from '../hooks/useFavicon';
import { SettingsAPI } from '../apis';
import { getFromCache, saveToCache } from '../utils/indexedDBCache';
export var ConfigContext = /*#__PURE__*/ React.createContext({});
export var ConfigProvider = function ConfigProvider(_ref) {
    var children = _ref.children;
    var initialConfigState = {
        selectedProduct: '',
        settings: {
            resourceType: '',
            id: 0,
            workspace_name: '',
            page_image: '',
            background_color: '',
            button_color: '',
            button_text_color: '',
            workspace_name_color: '',
            header_background_color: '',
            header_logo_image: '',
            industry_name: '',
            welcome_message_color: '',
            show_logo: false,
            show_workspace_name: true,
            show_deloitte_logo: false
        }
    };
    var _useState = useState(initialConfigState), _useState2 = _slicedToArray(_useState, 2), configState = _useState2[0], setConfigState = _useState2[1];
    // Always use default favicon - don't change based on header logo
    useFavicon('', false);
    var contextValue = useMemo(function () {
        return {
            configState: configState,
            setConfigState: setConfigState
        };
    }, [configState]); // value is cached by useMemo
    return /*#__PURE__*/ React.createElement(ConfigContext.Provider, {
        value: contextValue
    }, children);
};
// Ongoing request trackers to prevent duplicate API calls
var ongoingSettingsRequest = null;
var ongoingPageImageRequest = null;
var ongoingHeaderImageRequest = null;
// Hook to get settings with IndexedDB caching (persists until logout)
export var useSettingsData = function useSettingsData() {
    var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), cachedSettings = _useState4[0], setCachedSettings = _useState4[1];
    var CACHE_KEY = 'settings_data';
    var cachedSettingsRef = useRef(cachedSettings);
    useEffect(function () {
        cachedSettingsRef.current = cachedSettings;
    }, [cachedSettings]);
    var getSettings = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
        var cachedData, requestPromise, _t3;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        if (!(cachedSettingsRef.current !== null)) {
                            _context2.n = 1;
                            break;
                        }
                        return _context2.a(2, cachedSettingsRef.current);
                    case 1:
                        _context2.p = 1;
                        _context2.n = 2;
                        return getFromCache(CACHE_KEY);
                    case 2:
                        cachedData = _context2.v;
                        if (!(cachedData !== null)) {
                            _context2.n = 3;
                            break;
                        }
                        setCachedSettings(cachedData);
                        return _context2.a(2, cachedData);
                    case 3:
                        _context2.n = 5;
                        break;
                    case 4:
                        _context2.p = 4;
                        _t3 = _context2.v;
                        console.warn('Failed to read settings from IndexedDB cache:', _t3);
                    case 5:
                        if (!ongoingSettingsRequest) {
                            _context2.n = 6;
                            break;
                        }
                        return _context2.a(2, ongoingSettingsRequest);
                    case 6:
                        // 4. Fetch from API and cache the result
                        requestPromise = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                            var settings, _t, _t2;
                            return _regenerator().w(function (_context) {
                                while (1)
                                    switch (_context.p = _context.n) {
                                        case 0:
                                            _context.p = 0;
                                            _context.n = 1;
                                            return SettingsAPI.getSettings();
                                        case 1:
                                            settings = _context.v;
                                            // Update in-memory cache
                                            setCachedSettings(settings);
                                            // Update IndexedDB cache
                                            _context.p = 2;
                                            _context.n = 3;
                                            return saveToCache(CACHE_KEY, settings);
                                        case 3:
                                            _context.n = 5;
                                            break;
                                        case 4:
                                            _context.p = 4;
                                            _t = _context.v;
                                            console.warn('Failed to cache settings to IndexedDB:', _t);
                                        case 5:
                                            return _context.a(2, settings);
                                        case 6:
                                            _context.p = 6;
                                            _t2 = _context.v;
                                            ongoingSettingsRequest = null;
                                            throw _t2;
                                        case 7:
                                            _context.p = 7;
                                            ongoingSettingsRequest = null;
                                            return _context.f(7);
                                        case 8:
                                            return _context.a(2);
                                    }
                            }, _callee, null, [[2, 4], [0, 6, 7, 8]]);
                        }))(); // Store promise to prevent duplicates
                        ongoingSettingsRequest = requestPromise;
                        return _context2.a(2, requestPromise);
                }
        }, _callee2, null, [[1, 4]]);
    })), []);
    return getSettings;
};
// Hook to get page image with IndexedDB caching (persists until logout)
export var usePageImage = function usePageImage() {
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), cachedImage = _useState6[0], setCachedImage = _useState6[1];
    var CACHE_KEY = 'page_image_data';
    var cachedImageRef = useRef(cachedImage);
    useEffect(function () {
        cachedImageRef.current = cachedImage;
    }, [cachedImage]);
    var getPageImage = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
        var cachedData, requestPromise, _t6;
        return _regenerator().w(function (_context4) {
            while (1)
                switch (_context4.p = _context4.n) {
                    case 0:
                        if (!(cachedImageRef.current !== null)) {
                            _context4.n = 1;
                            break;
                        }
                        return _context4.a(2, cachedImageRef.current);
                    case 1:
                        _context4.p = 1;
                        _context4.n = 2;
                        return getFromCache(CACHE_KEY);
                    case 2:
                        cachedData = _context4.v;
                        if (!(cachedData !== null)) {
                            _context4.n = 3;
                            break;
                        }
                        setCachedImage(cachedData);
                        return _context4.a(2, cachedData);
                    case 3:
                        _context4.n = 5;
                        break;
                    case 4:
                        _context4.p = 4;
                        _t6 = _context4.v;
                        console.warn('Failed to read page image from IndexedDB cache:', _t6);
                    case 5:
                        if (!ongoingPageImageRequest) {
                            _context4.n = 6;
                            break;
                        }
                        return _context4.a(2, ongoingPageImageRequest);
                    case 6:
                        // 4. Fetch from API and cache the result
                        requestPromise = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
                            var image, _t4, _t5;
                            return _regenerator().w(function (_context3) {
                                while (1)
                                    switch (_context3.p = _context3.n) {
                                        case 0:
                                            _context3.p = 0;
                                            _context3.n = 1;
                                            return SettingsAPI.getSettingsImage('theme', 'image');
                                        case 1:
                                            image = _context3.v;
                                            // Update in-memory cache
                                            setCachedImage(image);
                                            // Update IndexedDB cache
                                            _context3.p = 2;
                                            _context3.n = 3;
                                            return saveToCache(CACHE_KEY, image);
                                        case 3:
                                            _context3.n = 5;
                                            break;
                                        case 4:
                                            _context3.p = 4;
                                            _t4 = _context3.v;
                                            console.warn('Failed to cache page image to IndexedDB:', _t4);
                                        case 5:
                                            return _context3.a(2, image);
                                        case 6:
                                            _context3.p = 6;
                                            _t5 = _context3.v;
                                            ongoingPageImageRequest = null;
                                            throw _t5;
                                        case 7:
                                            _context3.p = 7;
                                            ongoingPageImageRequest = null;
                                            return _context3.f(7);
                                        case 8:
                                            return _context3.a(2);
                                    }
                            }, _callee3, null, [[2, 4], [0, 6, 7, 8]]);
                        }))(); // Store promise to prevent duplicates
                        ongoingPageImageRequest = requestPromise;
                        return _context4.a(2, requestPromise);
                }
        }, _callee4, null, [[1, 4]]);
    })), []);
    return getPageImage;
};
// Hook to get header image with IndexedDB caching (persists until logout)
export var useHeaderImage = function useHeaderImage() {
    var _useState7 = useState(null), _useState8 = _slicedToArray(_useState7, 2), cachedImage = _useState8[0], setCachedImage = _useState8[1];
    var CACHE_KEY = 'header_image_data';
    var cachedImageRef = useRef(cachedImage);
    useEffect(function () {
        cachedImageRef.current = cachedImage;
    }, [cachedImage]);
    var getHeaderImage = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6() {
        var cachedData, requestPromise, _t9;
        return _regenerator().w(function (_context6) {
            while (1)
                switch (_context6.p = _context6.n) {
                    case 0:
                        if (!(cachedImageRef.current !== null)) {
                            _context6.n = 1;
                            break;
                        }
                        return _context6.a(2, cachedImageRef.current);
                    case 1:
                        _context6.p = 1;
                        _context6.n = 2;
                        return getFromCache(CACHE_KEY);
                    case 2:
                        cachedData = _context6.v;
                        if (!(cachedData !== null)) {
                            _context6.n = 3;
                            break;
                        }
                        setCachedImage(cachedData);
                        return _context6.a(2, cachedData);
                    case 3:
                        _context6.n = 5;
                        break;
                    case 4:
                        _context6.p = 4;
                        _t9 = _context6.v;
                        console.warn('Failed to read header image from IndexedDB cache:', _t9);
                    case 5:
                        if (!ongoingHeaderImageRequest) {
                            _context6.n = 6;
                            break;
                        }
                        return _context6.a(2, ongoingHeaderImageRequest);
                    case 6:
                        // 4. Fetch from API and cache the result
                        requestPromise = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
                            var image, _t7, _t8;
                            return _regenerator().w(function (_context5) {
                                while (1)
                                    switch (_context5.p = _context5.n) {
                                        case 0:
                                            _context5.p = 0;
                                            _context5.n = 1;
                                            return SettingsAPI.getSettingsImage('theme', 'logo');
                                        case 1:
                                            image = _context5.v;
                                            // Update in-memory cache
                                            setCachedImage(image);
                                            // Update IndexedDB cache
                                            _context5.p = 2;
                                            _context5.n = 3;
                                            return saveToCache(CACHE_KEY, image);
                                        case 3:
                                            _context5.n = 5;
                                            break;
                                        case 4:
                                            _context5.p = 4;
                                            _t7 = _context5.v;
                                            console.warn('Failed to cache header image to IndexedDB:', _t7);
                                        case 5:
                                            return _context5.a(2, image);
                                        case 6:
                                            _context5.p = 6;
                                            _t8 = _context5.v;
                                            ongoingHeaderImageRequest = null;
                                            throw _t8;
                                        case 7:
                                            _context5.p = 7;
                                            ongoingHeaderImageRequest = null;
                                            return _context5.f(7);
                                        case 8:
                                            return _context5.a(2);
                                    }
                            }, _callee5, null, [[2, 4], [0, 6, 7, 8]]);
                        }))(); // Store promise to prevent duplicates
                        ongoingHeaderImageRequest = requestPromise;
                        return _context6.a(2, requestPromise);
                }
        }, _callee6, null, [[1, 4]]);
    })), []);
    return getHeaderImage;
};
